module.exports = "<div class=\"error-page\">\n    <div class=\"error-container\">\n        <h1> 404 </h1>\n        <p>\n            {{ \"not.found.message\" | translate }}\n        </p>\n        <a [routerLink]=\"'/'\">\n            {{ \"title\" | translate }}\n        </a>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/not-found/not-found.component.html
// module id = ../../../../../src/app/components/not-found/not-found.component.html
// module chunks = main